import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/lib/useSite";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Booking from "@/pages/Booking";
import PhotographerLogin from "@/pages/PhotographerLogin";
import PhotographerPortal from "@/pages/PhotographerPortal";
import ClientDashboard from "@/pages/ClientDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import ClientJob from "@/pages/ClientJob";
import PublicDeliveryGallery from "@/pages/PublicDeliveryGallery";
import PropertyWebsite from "@/pages/PropertyWebsite";
import ResetPassword from "@/pages/ResetPassword";
import Work, { ProjectDetail } from "@/pages/Work";
import Services, { ServiceDetail } from "@/pages/Services";
import About, { Contact, Legal, CalendarConnected } from "@/pages/About";
import { WebDesign, WeddingsEvents } from "@/pages/ServiceExpansion";

const ADMIN_ROLES = ["admin", "operations"];

function ScrollToPageTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "auto" }); }, [pathname]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <SiteProvider>
        <BrowserRouter>
          <ScrollToPageTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/work" element={<Work />} />
            <Route path="/work/:slug" element={<ProjectDetail />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/pricing" element={<Navigate to="/services" replace />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/web-design" element={<WebDesign />} />
            <Route path="/weddings-events" element={<WeddingsEvents />} />
            <Route path="/privacy" element={<Legal kind="privacy" />} />
            <Route path="/terms" element={<Legal kind="terms" />} />
            <Route path="/calendar-connected" element={<CalendarConnected />} />
            <Route path="/book" element={<Booking />} />
            <Route path="/gallery/:slug" element={<PublicDeliveryGallery />} />
            <Route path="/listing/:slug" element={<PropertyWebsite />} />
            <Route path="/login" element={<Login />} />
            <Route path="/photographer/login" element={<PhotographerLogin />} />
            <Route path="/photographer/portal" element={<ProtectedRoute role="photographer"><PhotographerPortal /></ProtectedRoute>} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<ProtectedRoute role="client"><ClientDashboard /></ProtectedRoute>} />
            <Route path="/dashboard/jobs/:id" element={<ProtectedRoute role="client"><ClientJob /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute roles={ADMIN_ROLES}><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </SiteProvider>
    </AuthProvider>
  );
}

export default App;
